import { PlusOutlined } from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Spin,
} from 'antd';
import { useEffect, useState } from 'react';
import {
  fetchNalcoRateList,
  resetNalcoRateList,
  resetCurrentNalcoRatePage,
} from '../../slices/nalco-rate';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import ReactQuill from 'react-quill';
import initialTermsCondition from '../../Common/intialTermsCondition';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import {
  fetchAlloyDropdown,
  resetAlloyList,
  resetCurrentAlloyListPage,
} from '../../slices/alloy';
import {
  fetchTemperDropdown,
  resetCurrentTemperPage,
  resetTempersList,
} from '../../slices/tempers';
import {
  fetchCustomerDropdown,
  resetCurrentCustomerPage,
  resetCustomerList,
} from './../../slices/customer';
import {
  fetchDieProfileById,
  fetchDieProfileDropdown,
  resetCurrentDieProfilePage,
  resetDieProfileList,
} from './../../slices/die-profile';
import { fetchDieToolDetails } from './../../slices/die-tool';
import { fetchProformaById, updateProforma } from '../../slices/proforma';
import {
  fetchWorkOrderDropdown,
  resetWorkOrderList,
} from '../../slices/proforma';
import { createNumberValidationRule } from '../../utils/CreateNumberValidationRule';
import { fetchPackingModeList, resetPackingModeData } from '../../slices/packing';
import { fetchjobWorkList, resetJobWorkList } from '../../slices/job-work';
const { Option } = Select;

function EditProforma() {
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [editorValue, setEditorValue] = useState(initialTermsCondition);
  const { workOrderList: workOrderList = [] } = useSelector(
    state => state.proforma,
  );

  const { jobWorkdata, loading: jobWorkLoading } = useSelector(state => state.jobWork);
  const [searchTemper, setSearchTemper] = useState('');
  const [searchDieProfile, setSearchDieProfile] = useState('');
  const [searchAlloy, setSearchAlloy] = useState('');
  const [searchNalcoRate, setSearchNalcoRate] = useState('');
  const { id } = useParams();
  const dispatch = useDispatch();
  const [selectWorkOrder, setSelectWorkOrder] = useState();
  const [selectCustomer, setSelectCustomer] = useState(null);
  const [selectedDieProfile, setSelectedDieProfile] = useState([]);
  const [selectedAlloy, setSelectedAlloy] = useState([]);
  const [selectedTemper, setSelectedTemper] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [isDropdownLoading, setIsDropdownLoading] = useState(false);
  const [searchCustomer, setSearchCustomer] = useState('');
  const [isSelectLoading, setIsSelectLoading] = useState(true);
  const [pagesize, setPageSize] = useState(10);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedJobWork, setSelectedJobWork] = useState({});
  const [selectedSurfaceFinish, setSelectedSurfaceFinish] = useState({});
  const [selectedEngineeringOptions, setSelectedEngineeringOptions] = useState(
    {},
  );
  const { list: customerList } = useSelector(state => state.customer);
  const { data: packingModeList, loading: packingModeLoading } = useSelector(state => state.packingMode);

  const {
    list: NalcoRateList,
    loading: NalcoRateLoading,
    currentPage: NalcoRateCurrentPage,
    hasMore: NalcoRateHasMore,
  } = useSelector(state => state.nalcoRate);

  const {
    list: dieProfileList,
    loading: dieProfileLoading,
    currentPage: dieProfileCurrentPage,
    hasMore: dieProfileHasMore,
  } = useSelector(state => state.dieProfile);
  const {
    list: alloyList,
    loading: alloyLoading,
    currentPage: alloyCurrentPage,
    hasMore: alloyHasMore,
  } = useSelector(state => state.alloy);
  const {
    list: temperList,
    loading: temperLoading,
    hasMore: temperHasMore,
  } = useSelector(state => state.temper);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsSelectLoading(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    dispatch(
      fetchCustomerDropdown({
        page: 1,
        pagesize: 10000,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      }),
    );
    dispatch(
      fetchAlloyDropdown({
        page: 1,
        pagesize: 10000,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      }),
    );
    dispatch(
      fetchNalcoRateList({
        page: 1,
        pagesize: 10000,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      }),
    );
    dispatch(
      fetchTemperDropdown({
        page: 1,
        pagesize: 10000,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      }),
    );
    dispatch(
      fetchWorkOrderDropdown({
        page: 1,
        pagesize: 10000,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      }),
    );
    dispatch(fetchPackingModeList({ page: 1, pagesize: 100 }));
    dispatch(
      fetchDieProfileDropdown({
        page: 1,
        pagesize: 50000,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      }),
    );
    dispatch(resetCustomerList());
    dispatch(resetPackingModeData());
    dispatch(resetJobWorkList());
    dispatch(resetAlloyList());
    dispatch(resetTempersList());
    dispatch(resetNalcoRateList());
    dispatch(resetWorkOrderList());
    dispatch(resetDieProfileList());
  }, [dispatch, page, pagesize, search, orderBy]);


  const fetchProforma = async () => {
    try {
      const response = await dispatch(fetchProformaById({ id: id, print: false })).unwrap();
      if (response && response.results && response.results.data.length > 0) {
        const proformaData = response.results.data[0];
        const jobWorkResponse = await dispatch(fetchjobWorkList()).unwrap();
        const jobWorkMapName = Object.fromEntries(
          jobWorkResponse.results.data.map(item => [item.name, item.id]),
        );
        form.setFieldsValue({
          workorder: proformaData?.workorder,
          workorder_no: proformaData?.workorder_no,
          customer: proformaData?.customer || null,
          packing_mode: proformaData?.packing_mode,
          proforma_date: dayjs(proformaData.proforma_date),
          freight_charges: proformaData.freight_charges,
          advance_amount: proformaData.advance_amount,
          terms_and_condition: proformaData.terms_and_condition,
          delivery_schedule: proformaData.delivery_schedule,
          weight_range: proformaData.weight_range,
          remarks: proformaData.remarks,
          proforma_details: proformaData.proforma_details.map(detail => ({
            id: detail?.id,
            profile_no: detail.profile_no
              ? {
                label: detail.profile_no.die_number,
                value: detail.profile_no.id,
              }
              : undefined,
            customer_reference_no: detail.customer_reference_no || '',
            jobworks: Array.isArray(detail.jobworks)
              ? detail.jobworks.map(name => {
                const id = jobWorkMapName[name];
                if (!id)
                  console.warn(`No jobwork ID found for name: ${name}`);
                return id || name; // Fallback to name if ID not found
              })
              : [],
            alloy: detail.alloy
              ? {
                label: `${detail.alloy.name}${detail.alloy.color_code ? ' - ' + detail.alloy.color_code : ''}`,
                value: detail.alloy.id,
              }
              : null,
            temper: detail.temper
              ? { label: detail.temper.name, value: detail.temper.id }
              : undefined,
            length: parseInt(detail.length) || null,
            pieces: detail.pieces || null,
            net_weight: detail.net_weight || null,
            nalco_rate: detail.nalco_rate || null,
            packed_weight: detail.packed_weight || null,
            dispatch_qty: detail.dispatch_qty || null,
            conversion: detail?.conversion || null,
            cutting: detail.cutting || false,
            machinings: detail.machinings || false,
            deburring: detail.deburring || false,
            cutting_price: detail.cutting_price || undefined,
            machinings_price: detail.machinings_price || undefined,
            deburring_price: detail.deburring_price || undefined,
            anodising: detail.anodising || false,
            powder_coating: detail.powder_coating || false,
            pvdf: detail.pvdf || false,
            anodising_description: detail.anodising_description || undefined,
            anodising_price: detail.anodising_price || undefined,
            powder_coating_description:
              detail.powder_coating_description || undefined,
            powder_coating_price: detail.powder_coating_price || undefined,
            pvdf_description: detail.pvdf_description || undefined,
            pvdf_price: detail.pvdf_price || undefined,
            laser_marking_description:
              detail.laser_marking_description || undefined,
            laser_marking_price: detail.laser_marking_price || undefined,
            out_source: detail.out_source != null ? detail.out_source : null,
            wt_kg_p_mt: '',
          })),
        });

        const proformaDetails = proformaData.proforma_details || [];
        for (let index = 0; index < proformaDetails.length; index++) {
          const detail = proformaDetails[index];
          if (detail.profile_no?.id) {
            try {
              const response = await dispatch(
                fetchDieProfileById(detail.profile_no.id),
              ).unwrap();
              if (response?.results?.data?.length > 0) {
                const wtKgPerMt = response.results.data[0]?.wt_kg_p_mt || '';
                const updatedProformaDetails =
                  form.getFieldValue('proforma_details') || [];
                updatedProformaDetails[index] = {
                  ...updatedProformaDetails[index],
                  wt_kg_p_mt: wtKgPerMt ? parseFloat(wtKgPerMt).toFixed(3) : '',
                };
                form.setFieldsValue({
                  proforma_details: updatedProformaDetails,
                });

                if (
                  updatedProformaDetails[index].length &&
                  updatedProformaDetails[index].pieces
                ) {
                  handleFieldChange(index, 'length');
                } else if (updatedProformaDetails[index].net_weight) {
                  handleFieldChange(index, 'net_weight');
                }
              }
            } catch (error) {
              console.error('Error fetching die profile details:', error);
            }
          }
        }

        const jobWorkMap = {};
        const surfaceFinishMap = {};
        const engineeringOptionsMap = {};

        proformaData.proforma_details.forEach((detail, index) => {
          jobWorkMap[index] = detail.jobworks || [];
          const surfaceFinishArray = [];
          if (detail.anodising) surfaceFinishArray.push('anodising');
          if (detail.powder_coating) surfaceFinishArray.push('powder_coating');
          if (detail.pvdf) surfaceFinishArray.push('pvdf');
          surfaceFinishMap[index] = surfaceFinishArray;

          const engineeringArray = [];
          if (detail.cutting) engineeringArray.push('cutting');
          if (detail.machinings) engineeringArray.push('machinings');
          if (detail.deburring) engineeringArray.push('deburring');
          engineeringOptionsMap[index] = engineeringArray;
        });

        setSelectedJobWork(jobWorkMap);
        setSelectedSurfaceFinish(surfaceFinishMap);
        setSelectedEngineeringOptions(engineeringOptionsMap);
        setSelectWorkOrder(proformaData.workorder?.id);
        setSelectCustomer(proformaData.customer?.id);
        setSelectedDieProfile(
          proformaData.proforma_details
            .map(item => item.profile_no?.id)
            .filter(Boolean),
        );
        setSelectedAlloy(
          proformaData.proforma_details
            .map(item => item.alloy?.id)
            .filter(Boolean),
        );
        setSelectedTemper(
          proformaData.proforma_details
            .map(item => item.temper?.id)
            .filter(Boolean),
        );
      }
    } catch (error) {
      console.error('Error fetching proforma:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleJobWorkChange = (value, rowIndex) => {
    const updatedProformaDetails = [...form.getFieldValue('proforma_details')];
    const currentRow = updatedProformaDetails[rowIndex] || {};

    updatedProformaDetails[rowIndex] = { ...currentRow, jobworks: value };

    if (value.includes(2)) {
      updatedProformaDetails[rowIndex] = {
        ...updatedProformaDetails[rowIndex],
        cutting: currentRow.cutting || false,
        machinings: currentRow.machinings || false,
        deburring: currentRow.deburring || false,
        cutting_price: currentRow.cutting_price || undefined,
        machinings_price: currentRow.machinings_price || undefined,
        deburring_price: currentRow.deburring_price || undefined,
      };
    } else {
      updatedProformaDetails[rowIndex] = {
        ...updatedProformaDetails[rowIndex],
        cutting: false,
        machinings: false,
        deburring: false,
        cutting_price: undefined,
        machinings_price: undefined,
        deburring_price: undefined,
      };
      setSelectedEngineeringOptions(prev => ({ ...prev, [rowIndex]: [] }));
    }

    if (value.includes(5)) {
      updatedProformaDetails[rowIndex] = {
        ...updatedProformaDetails[rowIndex],
        laser_marking_description:
          currentRow.laser_marking_description || undefined,
        laser_marking_price: currentRow.laser_marking_price || undefined,
      };
    } else {
      updatedProformaDetails[rowIndex] = {
        ...updatedProformaDetails[rowIndex],
        laser_marking_description: undefined,
        laser_marking_price: undefined,
      };
    }

    if (value.includes(3)) {
      const surfaceFinishArray = [];
      if (currentRow.anodising) surfaceFinishArray.push('anodising');
      if (currentRow.powder_coating) surfaceFinishArray.push('powder_coating');
      if (currentRow.pvdf) surfaceFinishArray.push('pvdf');

      setSelectedSurfaceFinish(prev => ({
        ...prev,
        [rowIndex]: surfaceFinishArray,
      }));

      updatedProformaDetails[rowIndex] = {
        ...updatedProformaDetails[rowIndex],
        anodising: currentRow.anodising || false,
        powder_coating: currentRow.powder_coating || false,
        pvdf: currentRow.pvdf || false,
        anodising_description: currentRow.anodising_description || undefined,
        anodising_price: currentRow.anodising_price || undefined,
        powder_coating_description:
          currentRow.powder_coating_description || undefined,
        powder_coating_price: currentRow.powder_coating_price || undefined,
        pvdf_description: currentRow.pvdf_description || undefined,
        pvdf_price: currentRow.pvdf_price || undefined,
      };
    } else {
      setSelectedSurfaceFinish(prev => ({ ...prev, [rowIndex]: [] }));
      updatedProformaDetails[rowIndex] = {
        ...updatedProformaDetails[rowIndex],
        anodising: false,
        powder_coating: false,
        pvdf: false,
        anodising_description: undefined,
        anodising_price: undefined,
        powder_coating_description: undefined,
        powder_coating_price: undefined,
        pvdf_description: undefined,
        pvdf_price: undefined,
      };
    }
    // Handle Out Source field
    if (value.includes(4)) {
      // Out Source ID
      updatedProformaDetails[rowIndex] = {
        ...updatedProformaDetails[rowIndex],
        out_source:
          currentRow.out_source !== undefined ? currentRow.out_source : false,
      };
    } else {
      updatedProformaDetails[rowIndex] = {
        ...updatedProformaDetails[rowIndex],
        out_source: null,
      };
    }
    form.setFieldsValue({ proforma_details: updatedProformaDetails });
    setSelectedJobWork(prev => ({ ...prev, [rowIndex]: value }));
  };

  const handleCheckboxJobWorkChange = (field, checked, rowIndex) => {
    const updatedProformaDetails = [...form.getFieldValue('proforma_details')];

    if (['cutting', 'machinings', 'deburring'].includes(field)) {
      setSelectedEngineeringOptions(prev => {
        const prevSelected = prev[rowIndex] || [];
        let newSelected;
        if (checked) {
          newSelected = [...prevSelected, field];
        } else {
          newSelected = prevSelected.filter(f => f !== field);
        }
        return { ...prev, [rowIndex]: newSelected };
      });
    }

    if (['anodising', 'powder_coating', 'pvdf'].includes(field)) {
      setSelectedSurfaceFinish(prev => {
        const prevSelected = prev[rowIndex] || [];
        let newSelected;
        if (checked) {
          newSelected = [...prevSelected, field];
        } else {
          newSelected = prevSelected.filter(f => f !== field);
        }
        return { ...prev, [rowIndex]: newSelected };
      });
    }

    updatedProformaDetails[rowIndex] = {
      ...updatedProformaDetails[rowIndex],
      [field]: checked,
    };

    form.setFieldsValue({ proforma_details: updatedProformaDetails });
  };

  useEffect(() => {
    if (id) {
      fetchProforma();
    }
  }, [id]);

  const getClassNameCustomer = value => {
    const selected = customerList.find(item => item.id === selectCustomer);
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };

  const getClassNameDieProfile = index => {
    const value = selectedDieProfile[index];
    if (!value) return 'active-option';
    const selected = dieProfileList.find(item => item.id === value);
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };

  const getClassNameAlloy = index => {
    const value = selectedAlloy[index];
    if (!value) return 'active-option';
    const selected = alloyList.find(item => item.id === value);
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };

  const getClassNameTemer = index => {
    const value = selectedTemper[index];
    if (!value) return 'active-option';
    const selected = temperList.find(item => item.id === value);
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };

  const handleDropdownVisibleChange = open => {
    if (open && workOrderList.length === 0) {
      setIsDropdownLoading(true);
      setTimeout(() => {
        setIsDropdownLoading(false);
      }, 6000);
    }
  };



  useEffect(() => {
    if (form.getFieldValue('terms_and_condition')) {
      setEditorValue(form.getFieldValue('terms_and_condition'));
    }
  }, [form.getFieldValue('terms_and_condition')]);

  const handleChange = content => {
    setEditorValue(content);
    form.setFieldsValue({ terms_and_condition: content });
  };

  const onScrollNalcoRate = async event => {
    const target = event.target;
    if (
      !NalcoRateLoading &&
      NalcoRateHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(
        fetchNalcoRateList({ page: NalcoRateCurrentPage + 1, pagesize: 1000 }),
      );
    }
  };

  const getClassNameWorkOrder = value => {
    const selected = workOrderList.find(item => item.id === selectWorkOrder);
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };

  const handleSearchNalcoRate = value => {
    setSearchNalcoRate(value);
    if (value) {
      dispatch(resetNalcoRateList());
      dispatch(fetchNalcoRateList({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchNalcoRate('');
      dispatch(resetNalcoRateList());
      dispatch(resetCurrentNalcoRatePage());
      dispatch(fetchNalcoRateList({ page: 1, pagesize: 1000 }));
    }
  };

  const handleDieProfileChange = async (value, index) => {
    const updatedProformaDetails = [...form.getFieldValue('proforma_details')];
    updatedProformaDetails[index] = {
      ...updatedProformaDetails[index],
      profile_no: value?.value || null,
      customer_reference_no: '',
      wt_kg_p_mt: '',
    };
    form.setFieldsValue({
      proforma_details: updatedProformaDetails,
    });
    setSelectedIndex(index);

    try {
      dispatch(fetchDieToolDetails(value.label))
        .unwrap()
        .then(response => {
          if (response.success) {
            form.setFieldsValue({
              tool_number: response.data.tool_number,
              total_running_qty: response.data.total_running_qty,
              total_running_ton: response.data.total_running_ton,
            });
          }
        })
        .catch(error => {
          console.error('Error fetching die tool details:', error);
        });
    } catch (error) {
      console.error('Error in handleDieProfileChange:', error);
    }
  };

  const onScrollDieProfile = async event => {
    const target = event.target;
    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(
        fetchDieProfileDropdown({
          page: dieProfileCurrentPage + 1,
          pagesize: 5000,
        }),
      );
    }
  };

  const handleSearchDieProfile = value => {
    setSearchDieProfile(value);
    if (value) {
      dispatch(resetDieProfileList());
      dispatch(
        fetchDieProfileDropdown({ page: 1, pagesize: 5000, search: value }),
      );
    } else {
      setSearchDieProfile('');
      dispatch(resetDieProfileList());
      dispatch(resetCurrentDieProfilePage());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 5000 }));
    }
  };

  const handleSearchAlloy = value => {
    setSearchAlloy(value);
    if (value) {
      dispatch(resetAlloyList());
      dispatch(fetchAlloyDropdown({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchAlloy('');
      dispatch(resetAlloyList());
      dispatch(resetCurrentAlloyListPage());
      dispatch(fetchAlloyDropdown({ page: 1, pagesize: 1000 }));
    }
  };

  const onScrollAlloy = async event => {
    const target = event.target;
    if (
      !alloyLoading &&
      alloyHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(
        fetchAlloyDropdown({ page: alloyCurrentPage + 1, pagesize: 1000 }),
      );
    }
  };

  const handleSearchTemer = value => {
    setSearchTemper(value);
    if (value) {
      dispatch(resetTempersList());
      dispatch(fetchTemperDropdown({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchTemper('');
      dispatch(resetTempersList());
      dispatch(resetCurrentTemperPage());
      dispatch(fetchTemperDropdown({ page: 1, pagesize: 1000 }));
    }
  };

  const onScrollTemper = async event => {
    const target = event.target;
    if (
      !temperLoading &&
      temperHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchTemperDropdown({ page, pagesize: 1000 }));
    }
  };

  const handleFieldChange = (index, changedField) => {
    const proformaDetails = form.getFieldValue('proforma_details') || [];
    const row = { ...proformaDetails[index] } || {};
    const currentKg = parseFloat(row.wt_kg_p_mt) || 0;
    const length = parseFloat(row.length) || 0;
    const pieces = parseFloat(row.pieces) || 0;
    const netWeight = parseFloat(row.net_weight) || 0;

    let updatedRow = { ...row };

    if (currentKg > 0 && length > 0 && pieces >= 0) {
      if (changedField === 'net_weight' && netWeight > 0) {
        const calculatedPieces = netWeight / (currentKg * (length / 1000));
        updatedRow.pieces = Math.round(calculatedPieces);
        updatedRow.net_weight = netWeight.toFixed(2);
      } else if (changedField === 'pieces' || changedField === 'length') {
        const calculatedNetWeight = ((currentKg * length) / 1000) * pieces;
        updatedRow.net_weight = calculatedNetWeight.toFixed(2);
      }
    }

    const updatedProformaDetails = [...proformaDetails];
    updatedProformaDetails[index] = updatedRow;

    form.setFieldsValue({
      proforma_details: updatedProformaDetails,
    });
  };

  const handleWorkOrderSelect = async value => {
    setLoading(true);
    setSelectWorkOrder(value);
    const selectedWorkOrder = workOrderList.find(wo => wo.id === value);

    if (selectedWorkOrder) {
      form.setFieldsValue({
        workorder_no: selectedWorkOrder.order_no,
        customer: selectedWorkOrder.bill_to.id,
        packing_mode: selectedWorkOrder.packing_mode,
        proforma_date: dayjs(),
        freight_charges: selectedWorkOrder.freight_charges || '',
        advance_amount: selectedWorkOrder.advance_amount || '',
        delivery_schedule: selectedWorkOrder.delivery_schedule || '',
        weight_range: selectedWorkOrder.weight_range || '',
        remarks: selectedWorkOrder.remarks || '',
        proforma_details: selectedWorkOrder.work_order_details.map(detail => ({
          id: detail?.id,
          profile_no: detail.die_profile
            ? {
              label: detail.die_profile.die_number,
              value: detail.die_profile.id,
            }
            : undefined,
          alloy: detail.alloy
            ? {
              label: `${detail.alloy.alloy_code}${detail.alloy.standard_name ? ' - ' + detail.alloy.standard_name : ''}`,
              value: detail.alloy.id,
            }
            : undefined,
          temper: detail.temper
            ? { label: detail.temper.name, value: detail.temper.id }
            : undefined,
          customer_reference_no: detail.customer_reference_number || '',
          jobworks: detail.jobworks || [],
          length: detail.length || '',
          nalco_rate: detail.nalco_rate || '',
          dispatch_qty: detail.dispatch_qty || '',
          conversion: detail?.conversion || '',
          net_weight: detail.net_weight || '',
          packed_weight: detail.packed_weight || '',
          pieces: detail.pieces || '',
          cutting: detail.cutting || false,
          machinings: detail.machinings || false,
          deburring: detail.deburring || false,
          cutting_price: detail.cutting_price || undefined,
          machinings_price: detail.machinings_price || undefined,
          deburring_price: detail.deburring_price || undefined,
          anodising: detail.anodising || false,
          powder_coating: detail.powder_coating || false,
          pvdf: detail.pvdf || false,
          anodising_description: detail.anodising_description || undefined,
          anodising_price: detail.anodising_price || undefined,
          powder_coating_description:
            detail.powder_coating_description || undefined,
          powder_coating_price: detail.powder_coating_price || undefined,
          pvdf_description: detail.pvdf_description || undefined,
          pvdf_price: detail.pvdf_price || undefined,
          laser_marking_description:
            detail.laser_marking_description || undefined,
          laser_marking_price: detail.laser_marking_price || undefined,
        })) || [
            {
              profile_no: undefined,
              alloy: undefined,
              temper: undefined,
              customer_reference_no: '',
              jobworks: [],
              length: '',
              nalco_rate: '',
              dispatch_qty: '',
              conversion: 0,
              net_weight: '',
              packed_weight: '',
              pieces: '',
              cutting: false,
              machinings: false,
              deburring: false,
              cutting_price: undefined,
              machinings_price: undefined,
              deburring_price: undefined,
              anodising: false,
              powder_coating: false,
              pvdf: false,
              anodising_description: undefined,
              anodising_price: undefined,
              powder_coating_description: undefined,
              powder_coating_price: undefined,
              pvdf_description: undefined,
              pvdf_price: undefined,
              laser_marking_description: undefined,
              laser_marking_price: undefined,
            },
          ],
      });
      setSearchCustomer(selectedWorkOrder.bill_to.customer_name);

      const jobWorkMap = {};
      const surfaceFinishMap = {};
      const engineeringOptionsMap = {};

      selectedWorkOrder.work_order_details.forEach((detail, index) => {
        jobWorkMap[index] = detail.jobworks || [];
        const surfaceFinishArray = [];
        if (detail.anodising) surfaceFinishArray.push('anodising');
        if (detail.powder_coating) surfaceFinishArray.push('powder_coating');
        if (detail.pvdf) surfaceFinishArray.push('pvdf');
        surfaceFinishMap[index] = surfaceFinishArray;

        const engineeringArray = [];
        if (detail.cutting) engineeringArray.push('cutting');
        if (detail.machinings) engineeringArray.push('machinings');
        if (detail.deburring) engineeringArray.push('deburring');
        engineeringOptionsMap[index] = engineeringArray;
      });

      setSelectedJobWork(jobWorkMap);
      setSelectedSurfaceFinish(surfaceFinishMap);
      setSelectedEngineeringOptions(engineeringOptionsMap);

      const proformaDetails = selectedWorkOrder.work_order_details || [];
      for (let index = 0; index < proformaDetails.length; index++) {
        const detail = proformaDetails[index];
        if (detail.die_profile?.id) {
          try {
            const response = await dispatch(
              fetchDieProfileById(detail.die_profile.id),
            ).unwrap();
            if (response?.results?.data?.length > 0) {
              const wtKgPerMt = response.results.data[0]?.wt_kg_p_mt || '';
              const updatedProformaDetails =
                form.getFieldValue('proforma_details') || [];
              updatedProformaDetails[index] = {
                ...updatedProformaDetails[index],
                wt_kg_p_mt: wtKgPerMt ? parseFloat(wtKgPerMt).toFixed(3) : '',
              };
              form.setFieldsValue({
                proforma_details: updatedProformaDetails,
              });

              if (
                updatedProformaDetails[index].length &&
                updatedProformaDetails[index].pieces
              ) {
                handleFieldChange(index, 'length');
              }
            }
          } catch (error) {
            console.error('Error fetching die profile details:', error);
          }
        }
      }
    }
    setLoading(false);
  };

  const handleSearchCustomer = value => {
    setSearchCustomer(value);
    if (value) {
      dispatch(resetCustomerList());
      dispatch(fetchCustomerDropdown({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchCustomer('');
      dispatch(resetCustomerList());
      dispatch(resetCurrentCustomerPage());
      dispatch(fetchCustomerDropdown({ page: 1, pagesize: 1000 }));
    }
  };

  const handleChangeCustomer = value => {
    setSelectCustomer(value);
    setSearchCustomer(value);
  };

  const [btnLoading, setBtnLoading] = useState(false);

  const handleFinish = values => {
    setBtnLoading(true);
    values.proforma_date = dayjs(values.proforma_date).format('YYYY-MM-DD');
    const transformedProformaDetails = values.proforma_details.map(detail => {
      const transformedDetail = {
        id: detail ? detail.id : null,
        alloy: detail.alloy
          ? typeof detail.alloy === 'object'
            ? detail.alloy.value
            : detail.alloy
          : null,
        temper: detail.temper
          ? typeof detail.temper === 'object'
            ? detail.temper.value
            : detail.temper
          : null,
        profile_no: detail.profile_no
          ? typeof detail.profile_no === 'object'
            ? detail.profile_no.value
            : detail.profile_no
          : null,
        customer_reference_no: detail.customer_reference_no,
        jobworks: detail.jobworks || [],
        length: parseInt(detail.length) || null,
        pieces: parseInt(detail.pieces) || null,
        dispatch_qty: parseFloat(detail.dispatch_qty) || null,
        nalco_rate: parseFloat(detail.nalco_rate) || null,
        net_weight: parseFloat(detail.net_weight) || null,
        packed_weight: parseFloat(detail.packed_weight) || null,
      };

      if (detail.jobworks && detail.jobworks.includes(2)) {
        transformedDetail.cutting = detail.cutting || false;
        transformedDetail.machinings = detail.machinings || false;
        transformedDetail.deburring = detail.deburring || false;
        transformedDetail.cutting_price = detail.cutting_price
          ? parseFloat(detail.cutting_price)
          : undefined;
        transformedDetail.machinings_price = detail.machinings_price
          ? parseFloat(detail.machinings_price)
          : undefined;
        transformedDetail.deburring_price = detail.deburring_price
          ? parseFloat(detail.deburring_price)
          : undefined;
      }

      if (detail.jobworks && detail.jobworks.includes(3)) {
        transformedDetail.anodising = detail.anodising || false;
        transformedDetail.powder_coating = detail.powder_coating || false;
        transformedDetail.pvdf = detail.pvdf || false;
        transformedDetail.anodising_description =
          detail.anodising_description || undefined;
        transformedDetail.anodising_price = detail.anodising_price
          ? parseFloat(detail.anodising_price)
          : undefined;
        transformedDetail.powder_coating_description =
          detail.powder_coating_description || undefined;
        transformedDetail.powder_coating_price = detail.powder_coating_price
          ? parseFloat(detail.powder_coating_price)
          : undefined;
        transformedDetail.pvdf_description =
          detail.pvdf_description || undefined;
        transformedDetail.pvdf_price = detail.pvdf_price
          ? parseFloat(detail.pvdf_price)
          : undefined;
      }

      if (detail.jobworks && detail.jobworks.includes(5)) {
        transformedDetail.laser_marking_description =
          detail.laser_marking_description || undefined;
        transformedDetail.laser_marking_price = detail.laser_marking_price
          ? parseFloat(detail.laser_marking_price)
          : undefined;
      }

      if (detail?.jobworks?.includes(4) && detail?.out_source != null) {
        transformedDetail.out_source = detail?.out_source;
      }

      return transformedDetail;
    });

    const payload = {
      workorder: values.workorder,
      workorder_no: values.workorder_no,
      customer: values.customer,
      advance_amount: values.advance_amount,
      delivery_schedule: values.delivery_schedule,
      freight_charges: values.freight_charges,
      packing_mode: values.packing_mode,
      proforma_details: transformedProformaDetails,
      terms_and_condition: values.terms_and_condition,
      remarks: values.remarks,
      weight_range: values.weight_range,
    };

    dispatch(updateProforma({ id: id, values: payload }))
      .unwrap()
      .then(result => {
        if (result.success) {
          setBtnLoading(false);
          message.success('Proforma Updated Successfully!');
          navigate('/proforma-list');
        }
      })
      .catch(error => {
        setBtnLoading(false);
        let displayMessage = '';
        if (typeof error === 'object') {
          displayMessage = Object.entries(error)
            .map(([key, value]) => `${key}: ${value.join(', ')}`)
            .join('\n');
          message.error(displayMessage);
        } else {
          message.error(`Error: ${error || 'Failed to update the proforma.'}`);
        }
      });
  };

  return (
    <>
      <div className="sticyaction">
        <div className="pagenamerow mb-0">
          <h2>Edit Proforma</h2>
          <div className="bredcrumbwrp">
            <Link className="back" onClick={() => navigate(-1)}>
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                { title: <Link to="/proforma-list">Proforma List</Link> },
                { title: 'Edit Proforma' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form form={form} layout="vertical" onFinish={handleFinish}>
          <Row gutter={16}>
            <Col xs={12} sm={10} md={8}>
              <Form.Item
                name="workorder"
                label="Select Work Order"
              >
                {isSelectLoading ? (
                  <div
                    style={{
                      border: '1px solid #d9d9d9',
                      borderRadius: 6,
                      height: 40,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: '#fff',
                    }}
                  >
                    <Spin size="small" />
                  </div>
                ) : (
                  <AutoOpenSelect
                    placeholder="Order No - Order Date - PO Number - PO Date - Customer Name"
                    onChange={handleWorkOrderSelect}
                    className={getClassNameWorkOrder()}
                    showSearch
                    optionFilterProp="children"
                    onDropdownVisibleChange={handleDropdownVisibleChange}
                    value={form.getFieldValue('workorder')}
                    disabled
                  >
                    {workOrderList.map(wo => (
                      <Option
                        key={wo.id}
                        value={wo.id}
                        disabled={wo.deleted === 1}
                      >
                        {`${wo.order_no} - ${wo.order_date} - ${wo.purchase_order_no} - ${wo.purchase_order_date} - ${wo.bill_to.customer_name}`}
                      </Option>
                    ))}
                  </AutoOpenSelect>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={10} sm={8} md={4} lg={4}>
              <Form.Item
                name="workorder_no"
                label="Work Order No"
                rules={[
                  { required: true, message: 'Please enter valid work order no' },
                ]}
              >
                <Input placeholder="Enter Work Order No" />
              </Form.Item>
            </Col>
            <Col xs={10} sm={10} md={4} lg={5}>
              <Form.Item
                name="customer"
                label="Customer"
                rules={[
                  { required: true, message: 'Please select customer name' },
                ]}
              >
                <AutoOpenSelect
                  value={searchCustomer}
                  placeholder="Please Select Customer"
                  onChange={handleChangeCustomer}
                  className={getClassNameCustomer()}
                  allowClear
                  showSearch
                  onSearch={handleSearchCustomer}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {[
                    ...new Map(
                      customerList.map(item => [item.id, item]),
                    ).values(),
                  ].map(el => (
                    <Option
                      key={el.id}
                      value={el.id}
                      disabled={el.deleted === 1}
                    >
                      {el.customer_name}
                    </Option>
                  ))}
                </AutoOpenSelect>
              </Form.Item>
            </Col>
            <Col xs={10} sm={10} md={4} lg={4}>

              <Form.Item
                name="packing_mode"
                label="Mode Of Packing"
                rules={[
                  { required: true, message: 'Please select mode of packing' },
                ]}
              >
                <AutoOpenSelect
                  placeholder="Select Mode Of Packing"
                  options={Array.from(
                    new Map(
                      packingModeList.map(item => [item.id, { label: item.name, value: item.id }])
                    ).values()
                  )}
                  mode="multiple"
                  loading={packingModeLoading}
                />
              </Form.Item>
            </Col>
            <Col xs={10} sm={8} md={3} lg={3}>
              <Form.Item
                name="proforma_date"
                label="Proforma Date"
                rules={[
                  { required: true, message: 'Please select proforma date' },
                ]}
              >
                <DatePicker format="DD-MM-YYYY" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col xs={10} sm={8} md={4} lg={4}>
              <Form.Item
                name="freight_charges"
                label="Freight Charges"
                rules={[
                  createNumberValidationRule({
                    allowNegative: false,
                    maxBeforeDecimal: 7,
                    maxAfterDecimal: 3,
                    allowDecimal: true,
                    allowZero: true,
                  }),
                ]}
              >
                <Input
                  placeholder="Enter Freight Charges"
                  onChange={e => {
                    const value = e.target.value;
                    const formattedValue = value
                      .toLowerCase()
                      .replace(/\b\w/g, char => char.toUpperCase());
                    form.setFieldsValue({ freight_charges: formattedValue });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={10} sm={8} md={4} lg={4}>
              <Form.Item
                name="advance_amount"
                label="Advance Amount"
                rules={[
                  createNumberValidationRule({
                    allowNegative: false,
                    maxBeforeDecimal: 7,
                    maxAfterDecimal: 3,
                    allowDecimal: true,
                    allowZero: true,
                  }),
                ]}
              >
                <Input
                  placeholder="Enter Advance Amount"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="formrowsection">
            <h3 className="rowsubtitle">Add New Item</h3>
            <Form.List name="proforma_details">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Row
                      className="rowItem mx-0"
                      gutter={[24, 24]}
                      align="middle"
                      key={key}
                      style={{ width: '100%' }}
                    >
                      <Col flex="auto">
                        <Row gutter={16}>
                          <Col xs={12} sm={8} md={6} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'profile_no']}
                              label="Section Number"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select a section number',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Section Number"
                                style={{ width: '100%' }}
                                labelInValue
                                value={form.getFieldValue([
                                  'proforma_details',
                                  name,
                                  'profile_no',
                                ])}
                                onChange={value =>
                                  handleDieProfileChange(value, name)
                                }
                                onSearch={handleSearchDieProfile}
                                className={getClassNameDieProfile(name)}
                                allowClear
                                showSearch
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                loading={dieProfileLoading}
                                onPopupScroll={onScrollDieProfile}
                                notFoundContent={
                                  dieProfileLoading
                                    ? 'Loading...'
                                    : 'No options'
                                }
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {dieProfileList.map(el => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el.die_number}
                                  </Option>
                                ))}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} md={6} xl={4}>
                            <Form.Item
                              name={[name, 'customer_reference_no']}
                              label="Customer Reference No."
                            >
                              <Input placeholder="Please enter customer Ref.No" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} md={6} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'alloy']}
                              label="Alloy"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select alloy',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Alloy"
                                loading={alloyLoading}
                                className={getClassNameAlloy(name)}
                                onPopupScroll={onScrollAlloy}
                                notFoundContent={
                                  alloyLoading ? 'Loading...' : 'No options'
                                }
                                value={form.getFieldValue([
                                  'proforma_details',
                                  name,
                                  'alloy',
                                ])}
                                onChange={value =>
                                  form.setFieldValue(
                                    ['proforma_details', name, 'alloy'],
                                    value,
                                  )
                                }
                                onSearch={handleSearchAlloy}
                                allowClear
                                showSearch
                                filterOption={(input, option) => {
                                  if (!input) return true;
                                  const optionText = (option?.children || '')
                                    .toString()
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  const inputText = input
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  return optionText.includes(inputText);
                                }}
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {alloyList.map(el => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el.alloy_code} - {el.standard_name}
                                  </Option>
                                ))}
                                {alloyLoading && <Option>Loading...</Option>}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} md={6} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'temper']}
                              label="Temper"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select temper',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Temper"
                                loading={temperLoading}
                                onPopupScroll={onScrollTemper}
                                className={getClassNameTemer(name)}
                                value={form.getFieldValue([
                                  'proforma_details',
                                  name,
                                  'temper',
                                ])}
                                onChange={value =>
                                  form.setFieldValue(
                                    ['proforma_details', name, 'temper'],
                                    value,
                                  )
                                }
                                filterOption={(input, option) => {
                                  if (!input) return true;
                                  const optionText = (option?.children || '')
                                    .toString()
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  const inputText = input
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  return optionText.includes(inputText);
                                }}
                                onSearch={handleSearchTemer}
                                allowClear
                                showSearch
                                notFoundContent={
                                  temperLoading ? 'Loading...' : 'No options'
                                }
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {temperList.map(el => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el.temper_code_new} - {el.temper_code_old}
                                  </Option>
                                ))}
                                {temperLoading && <Option>Loading...</Option>}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} md={6} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'length']}
                              label="Length (mm)"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter length',
                                },
                                {
                                  validator: (_, value) => {
                                    if (!value) return Promise.resolve();
                                    const regex = /^[0-9]*\.?[0-9]+$/;
                                    if (
                                      regex.test(value) &&
                                      parseFloat(value) > 0
                                    ) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      'Length must be a positive number',
                                    );
                                  },
                                },
                              ]}
                            >
                              <Input
                                placeholder="0"
                                onChange={e => {
                                  const value = e.target.value;
                                  if (
                                    /^\d{0,7}(\.\d{0,3})?$/.test(value) ||
                                    value === ''
                                  ) {
                                    form.setFieldValue(
                                      ['proforma_details', name, 'length'],
                                      value,
                                    );
                                    handleFieldChange(index, 'length');
                                  }
                                }}
                                onBlur={() => {
                                  const value = form.getFieldValue([
                                    'proforma_details',
                                    name,
                                    'length',
                                  ]);
                                  if (value) {
                                    form.setFieldValue(
                                      ['proforma_details', name, 'length'],
                                      parseFloat(value).toFixed(2),
                                    );
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} lg={6} xxl={4}>
                            <Form.Item
                              name={[name, 'pieces']}
                              label="Pieces"
                              rules={[
                                {
                                  pattern: /^\d{1,6}$/,
                                  message:
                                    'Please enter a number with up to 6 digits',
                                },
                              ]}
                            >
                              <Input
                                placeholder="0"
                                onChange={e => {
                                  const value = e.target.value;
                                  if (/^\d{0,6}$/.test(value) || value === '') {
                                    form.setFieldValue(
                                      ['proforma_details', name, 'pieces'],
                                      value,
                                    );
                                    handleFieldChange(index, 'pieces');
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} lg={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'net_weight']}
                              label="Net Weight (kg)"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (!value && value !== 0)
                                      return Promise.resolve();
                                    const regex = /^[0-9]*\.?[0-9]+$/;
                                    if (
                                      regex.test(value) &&
                                      parseFloat(value) >= 0
                                    ) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      'Net weight (kg) must be a positive number',
                                    );
                                  },
                                },
                                createNumberValidationRule({
                                  allowNegative: false,
                                  maxBeforeDecimal: 7,
                                  maxAfterDecimal: 3,
                                  allowDecimal: true,
                                  allowZero: true,
                                }),
                              ]}
                            >
                              <Input
                                placeholder="0.00"
                                onChange={e => {
                                  const value = e.target.value;
                                  if (
                                    /^\d{0,7}(\.\d{0,3})?$/.test(value) ||
                                    value === ''
                                  ) {
                                    form.setFieldValue(
                                      ['proforma_details', name, 'net_weight'],
                                      value,
                                    );
                                    handleFieldChange(index, 'net_weight');
                                  }
                                }}
                                onBlur={() => {
                                  const value = form.getFieldValue([
                                    'proforma_details',
                                    name,
                                    'net_weight',
                                  ]);
                                  if (value) {
                                    form.setFieldValue(
                                      ['proforma_details', name, 'net_weight'],
                                      parseFloat(value).toFixed(2),
                                    );
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} lg={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'nalco_rate']}
                              label="Nalco Rate"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select nalco rate',
                                },
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} md={6} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'packed_weight']}
                              label="Packed Weight (kg)"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (!value && value !== 0)
                                      return Promise.resolve();
                                    const regex = /^[0-9]*\.?[0-9]+$/;
                                    if (
                                      regex.test(value) &&
                                      parseFloat(value) >= 0
                                    ) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      'Packed weight (kg) must be a positive number or zero',
                                    );
                                  },
                                },
                                createNumberValidationRule({
                                  allowNegative: false,
                                  maxBeforeDecimal: 7,
                                  maxAfterDecimal: 3,
                                  allowDecimal: true,
                                  allowZero: true,
                                }),
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} md={6} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'dispatch_qty']}
                              label="Dispatch Qty"
                              rules={[
                                {
                                  validator: (_, value) => {
                                    if (
                                      value === undefined ||
                                      value === null ||
                                      value === ''
                                    ) {
                                      return Promise.resolve();
                                    }
                                    const regex = /^\d{1,5}$/;
                                    if (regex.test(value.toString())) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      'Dispatch Qty must be a number with max 5 digits',
                                    );
                                  },
                                },
                              ]}
                            >
                              <Input placeholder="0" maxLength={5} />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'conversion']}
                              label="Conversion"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid Conversion',
                                },
                                createNumberValidationRule({
                                  allowNegative: false,
                                  maxBeforeDecimal: 10,
                                  maxAfterDecimal: 3,
                                  allowDecimal: true,
                                  allowZero: true,
                                }),
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'jobworks']}
                              label="Surface finish"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select surface finish',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Jobwork"
                                mode="multiple"
                                value={form.getFieldValue([
                                  'proforma_details',
                                  name,
                                  'jobworks',
                                ])}
                                allowClear
                                showSearch
                                optionFilterProp="children"
                                onChange={value => {
                                  form.setFieldValue(
                                    ['proforma_details', name, 'jobworks'],
                                    value,
                                  );
                                  handleJobWorkChange(value, name);
                                }}
                                loading={jobWorkLoading}
                              >
                                {jobWorkLoading ? (
                                  <Option key="loading" disabled>
                                    Loading...
                                  </Option>
                                ) : (
                                  jobWorkdata?.map(item => (
                                    <Option key={item.id} value={item.id}>
                                      {item.name}
                                    </Option>
                                  ))
                                )}
                              </AutoOpenSelect>
                              {selectedJobWork[name]?.includes(2) && (
                                <Space>
                                  <Form.Item
                                    name={[name, 'cutting']}
                                    valuePropName="checked"
                                    style={{ margin: '0' }}
                                  >
                                    <Checkbox
                                      style={{ marginTop: '8px' }}
                                      onChange={e =>
                                        handleCheckboxJobWorkChange(
                                          'cutting',
                                          e.target.checked,
                                          name,
                                        )
                                      }
                                    >
                                      Cutting
                                    </Checkbox>
                                  </Form.Item>
                                  <Form.Item
                                    name={[name, 'machinings']}
                                    valuePropName="checked"
                                    style={{ margin: '0' }}
                                  >
                                    <Checkbox
                                      style={{ marginTop: '8px' }}
                                      onChange={e =>
                                        handleCheckboxJobWorkChange(
                                          'machinings',
                                          e.target.checked,
                                          name,
                                        )
                                      }
                                    >
                                      Machining
                                    </Checkbox>
                                  </Form.Item>
                                  <Form.Item
                                    name={[name, 'deburring']}
                                    valuePropName="checked"
                                    style={{ margin: '0' }}
                                  >
                                    <Checkbox
                                      style={{ marginTop: '8px' }}
                                      onChange={e =>
                                        handleCheckboxJobWorkChange(
                                          'deburring',
                                          e.target.checked,
                                          name,
                                        )
                                      }
                                    >
                                      Deburring
                                    </Checkbox>
                                  </Form.Item>
                                </Space>
                              )}
                              {selectedJobWork[name]?.includes(3) && (
                                <Space>
                                  <Form.Item
                                    name={[name, 'anodising']}
                                    valuePropName="checked"
                                    style={{ margin: '0' }}
                                  >
                                    <Checkbox
                                      style={{ marginTop: '8px' }}
                                      onChange={e =>
                                        handleCheckboxJobWorkChange(
                                          'anodising',
                                          e.target.checked,
                                          name,
                                        )
                                      }
                                    >
                                      Anodising
                                    </Checkbox>
                                  </Form.Item>
                                  <Form.Item
                                    name={[name, 'powder_coating']}
                                    valuePropName="checked"
                                    style={{ margin: '0' }}
                                  >
                                    <Checkbox
                                      style={{ marginTop: '8px' }}
                                      onChange={e =>
                                        handleCheckboxJobWorkChange(
                                          'powder_coating',
                                          e.target.checked,
                                          name,
                                        )
                                      }
                                    >
                                      Powder Coating
                                    </Checkbox>
                                  </Form.Item>
                                  <Form.Item
                                    name={[name, 'pvdf']}
                                    valuePropName="checked"
                                    style={{ margin: '0' }}
                                  >
                                    <Checkbox
                                      style={{ marginTop: '8px' }}
                                      onChange={e =>
                                        handleCheckboxJobWorkChange(
                                          'pvdf',
                                          e.target.checked,
                                          name,
                                        )
                                      }
                                    >
                                      PVDF
                                    </Checkbox>
                                  </Form.Item>
                                </Space>
                              )}
                            </Form.Item>
                          </Col>
                          {selectedSurfaceFinish[name]?.includes(
                            'anodising',
                          ) && (
                              <>
                                <Col>
                                  <Form.Item
                                    name={[name, 'anodising_description']}
                                    label="Anodising Description"
                                  >
                                    <Input placeholder="Enter Description" />
                                  </Form.Item>
                                </Col>
                                <Col>
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'anodising_price']}
                                    label="Anodising Price"
                                    rules={[
                                      createNumberValidationRule({
                                        allowNegative: false,
                                        maxBeforeDecimal: 10,
                                        maxAfterDecimal: 3,
                                        allowDecimal: true,
                                        allowZero: true,
                                      }),
                                    ]}
                                  >
                                    <Input placeholder="0.0" />
                                  </Form.Item>
                                </Col>
                              </>
                            )}
                          {selectedSurfaceFinish[name]?.includes(
                            'powder_coating',
                          ) && (
                              <>
                                <Col>
                                  <Form.Item
                                    name={[name, 'powder_coating_description']}
                                    label="Powder Coating Description"
                                  >
                                    <Input placeholder="Enter Description" />
                                  </Form.Item>
                                </Col>
                                <Col>
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'powder_coating_price']}
                                    label="Powder Coating Price"
                                    rules={[
                                      createNumberValidationRule({
                                        allowNegative: false,
                                        maxBeforeDecimal: 10,
                                        maxAfterDecimal: 3,
                                        allowDecimal: true,
                                        allowZero: true,
                                      }),
                                    ]}
                                  >
                                    <Input placeholder="0.0" />
                                  </Form.Item>
                                </Col>
                              </>
                            )}
                          {selectedSurfaceFinish[name]?.includes('pvdf') && (
                            <>
                              <Col>
                                <Form.Item
                                  name={[name, 'pvdf_description']}
                                  label="PVDF Description"
                                >
                                  <Input placeholder="Enter Description" />
                                </Form.Item>
                              </Col>
                              <Col>
                                <Form.Item
                                  {...restField}
                                  name={[name, 'pvdf_price']}
                                  label="PVDF Price"
                                  rules={[
                                    createNumberValidationRule({
                                      allowNegative: false,
                                      maxBeforeDecimal: 10,
                                      maxAfterDecimal: 3,
                                      allowDecimal: true,
                                      allowZero: true,
                                    }),
                                  ]}
                                >
                                  <Input placeholder="0.0" />
                                </Form.Item>
                              </Col>
                            </>
                          )}
                          {selectedEngineeringOptions[name]?.includes(
                            'cutting',
                          ) && (
                              <Col>
                                <Form.Item
                                  name={[name, 'cutting_price']}
                                  label="Cutting Price"
                                  rules={[
                                    createNumberValidationRule({
                                      allowNegative: false,
                                      maxBeforeDecimal: 10,
                                      maxAfterDecimal: 3,
                                      allowDecimal: true,
                                      allowZero: true,
                                    }),
                                  ]}
                                >
                                  <Input placeholder="Enter Cutting Price" />
                                </Form.Item>
                              </Col>
                            )}
                          {selectedEngineeringOptions[name]?.includes(
                            'machinings',
                          ) && (
                              <Col>
                                <Form.Item
                                  name={[name, 'machinings_price']}
                                  label="Machining Price"
                                  rules={[
                                    createNumberValidationRule({
                                      allowNegative: false,
                                      maxBeforeDecimal: 10,
                                      maxAfterDecimal: 3,
                                      allowDecimal: true,
                                      allowZero: true,
                                    }),
                                  ]}
                                >
                                  <Input placeholder="Enter Machining Price" />
                                </Form.Item>
                              </Col>
                            )}
                          {selectedEngineeringOptions[name]?.includes(
                            'deburring',
                          ) && (
                              <Col>
                                <Form.Item
                                  name={[name, 'deburring_price']}
                                  label="Deburring Price"
                                  rules={[
                                    createNumberValidationRule({
                                      allowNegative: false,
                                      maxBeforeDecimal: 10,
                                      maxAfterDecimal: 3,
                                      allowDecimal: true,
                                      allowZero: true,
                                    }),
                                  ]}
                                >
                                  <Input placeholder="Enter Deburring Price" />
                                </Form.Item>
                              </Col>
                            )}
                          {selectedJobWork[name]?.includes(5) && (
                            <>
                              <Col>
                                <Form.Item
                                  name={[name, 'laser_marking_description']}
                                  label="Laser Marking Description"
                                >
                                  <Input placeholder="Enter Laser Marking Description" />
                                </Form.Item>
                              </Col>
                              <Col>
                                <Form.Item
                                  name={[name, 'laser_marking_price']}
                                  label="Laser Marking Price"
                                  rules={[
                                    createNumberValidationRule({
                                      allowNegative: false,
                                      maxBeforeDecimal: 10,
                                      maxAfterDecimal: 3,
                                      allowDecimal: true,
                                      allowZero: true,
                                    }),
                                  ]}
                                >
                                  <Input placeholder="Enter Laser Marking Price" />
                                </Form.Item>
                              </Col>
                            </>
                          )}
                          {selectedJobWork[name] &&
                            selectedJobWork[name].includes(4) && (
                              <>
                                <Col>
                                  <Form.Item
                                    name={[name, 'out_source']}
                                    label="Out Source"
                                  >
                                    <AutoOpenSelect placeholder="Select Jobwork">
                                      <Option value={true}>Yes</Option>
                                      <Option value={false}>No</Option>
                                    </AutoOpenSelect>
                                  </Form.Item>
                                </Col>
                              </>
                            )}
                        </Row>
                      </Col>
                    </Row>
                  ))}
                </>
              )}
            </Form.List>
          </div>
          <Row gutter={16}>
            <Col xs={24}>
              <Form.Item
                name="terms_and_condition"
                label="Terms & Condition"
                rules={[
                  { required: true, message: 'Terms & Condition is required' },
                ]}
                valuePropName="content" // Key for form data
              >
                <ReactQuill
                  value={editorValue}
                  onChange={handleChange}
                  theme="snow"
                  modules={{
                    toolbar: [
                      [{ header: '1' }, { header: '2' }, { font: [] }],
                      [{ list: 'ordered' }, { list: 'bullet' }],
                      ['bold', 'italic', 'underline'],
                      [{ align: [] }],
                      ['link', 'image'],
                      ['blockquote', 'code-block'],
                    ],
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={10}>
            <Col xs={12} sm={12} md={12} xl={8}>
              <Form.Item name="delivery_schedule" label="Delivery Schedule">
                <Input.TextArea
                  placeholder="20-25 Days for supply from the date of purchase order."
                  onChange={e => {
                    const value = e.target.value;
                    const formattedValue = value
                      .toLowerCase()
                      .replace(/\b\w/g, char => char.toUpperCase());
                    form.setFieldsValue({ delivery_schedule: formattedValue });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={12} sm={12} md={12} xl={8}>
              <Form.Item name="weight_range" label="Weight Range">
                <Input.TextArea
                  placeholder="Delivery Weight will be 10% on work order"
                  onChange={e => {
                    const value = e.target.value;
                    const formattedValue = value
                      .toLowerCase()
                      .replace(/\b\w/g, char => char.toUpperCase());
                    form.setFieldsValue({ weight_range: formattedValue });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={12} sm={12} md={12} xl={8}>
              <Form.Item name="remarks" label="Remarks">
                <Input.TextArea
                  placeholder="Enter Remark"
                  onChange={e => {
                    const value = e.target.value;
                    const formattedValue = value
                      .toLowerCase()
                      .replace(/\b\w/g, char => char.toUpperCase());
                    form.setFieldsValue({ remarks: formattedValue });
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="flex justify-end">
            <Button
              type="primary"
              htmlType="submit"
              loading={btnLoading}
              icon={<PlusOutlined />}
            >
              Edit Proforma
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}

export default EditProforma;
